import { AfterViewInit, Component, ElementRef, Input, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { AppClientContext } from 'src/app-client/_appCommon/base/AppClientContext';
import { BroadcastManager } from 'src/app-client/_appCommon/base/BroadcastManager';
import { UrlQueryDef } from 'src/app-client/_appCommon/base/UrlQueryDef';
import { CaseFileDataService } from 'src/app-client/_dataservices/CaseFileDataService';
import { SliderImagesDataService } from 'src/app-client/_dataservices/SliderImagesDataService';
@Component({
  selector: 'app-image-slider',
  templateUrl: './image-slider.component.html',
  styleUrls: ['./image-slider.component.css'],
  providers:[CaseFileDataService]
})
export class ImageSliderComponent implements OnInit,AfterViewInit {
  public width:number=0;

  @ViewChild('slides') slidesContainer: ElementRef<HTMLDivElement>;
  @ViewChild('slide') slide: ElementRef;
  @ViewChild('showImageDialog') protected showImage: any;
  private caseFileResponse: any[];
  public imagesArray: any[]=[];
  //public sliderImagesArray: any[]=[];
  private setup: any;
  public displayImage:string="";

  constructor(private caseFileDataService : CaseFileDataService,
    private sliderImagesDataService:SliderImagesDataService
  ) { }
  ngAfterViewInit(): void {
      this.width=216;
  }

  ngOnInit(): void {
    this.setup=AppClientContext.Instance.setup;
    this.getAllCaseFiles();
    //this.sliderImagesArray=this.sliderImagesDataService.getImages();

    BroadcastManager.Instance.on("update-files-carrousel")
    .subscribe(([e]) =>
    {
      this.setup=AppClientContext.Instance.setup;
      this.getAllCaseFiles();
      //this.sliderImagesArray=this.sliderImagesDataService.getImages();
    });
        
  }

  private getAllCaseFiles(): void
  {
    if(this.setup)
    {
      let body={
        caseFileId: this.setup.caseFileId
      }
      this.caseFileDataService.getAllCaseFilesBySetup(body)
        .subscribe((response: any) =>
        {
          this.imagesArray = [];
          this.caseFileResponse = response;
          let parse=JSON.parse(JSON.stringify(this.caseFileResponse))
          Object.entries(parse).forEach(([key, value]) => {
            if(value!=null && key!="id")
            {
              this.imagesArray.push({key,value})
            }
            
        });
          this.imagesArray=this.imagesArray.filter(x=>x.value.mediaType==1 ||x.value.mediaType==2 )
        });
    }
    
  }

  public getName(params)
  {

    if(params == "composite")
    { 
      return "Composite";
    }
    else if (params == "additionalRadiography") {
      return "Radiografía Adicional";
    }
    else if (params == "frontalIntraoral") {
      return "Fotografía Intraoral Frontal";
    }
    else if (params == "upperOcclusal") {
      return "Fotografía Oclusal Superior";
    }
    else if (params == "lowerOcclusal") {
      return "Fotografía oclusal Inferior";
    }
    else if (params == "leftLateralIntraoral") {
      return "Fotografía Intraoral Lateral Izquierda";
    }
    else if (params == "rightLateralIntraoral") {
      return "Fotografía Intraoral Lateral derecha";
    }
    else if (params == "frontalExtraoral") {
      return "Fotografía Extraoral Frontal";
    }
    else if (params == "lateralExtraoral") {
      return "Fotografía Extraoral Lateral";
    }
    else if (params == "smileExtraoral") {
      return "Fotografía Extraoral Sonrisa";
    }
    else if (params == "panoramicRadiography") {
      return "Fotografía Radiagrafía Panorámica";
    }
    else if (params == "lateralRadiography") {
      return "Fotografía Radiografía Lateral";
    }
    else if (params == "biteSTL") {
      return "Fotografía Mordida y otros STL";
    }
    else if (params == "upperSTL") {
      return "Fotografía Superior STL";
    }
    else if (params == "lowerSTL") {
      return "Fotografía Inferior STL";
    }


  }

  onGetQueryDefForGetCaseFilesById(): UrlQueryDef
  {
    let queryDef = new UrlQueryDef();
    queryDef.includes = "FrontalIntraoral,UpperOcclusal,LowerOcclusal,LeftLateralIntraoral,RightLateralIntraoral,FrontalExtraoral,LateralExtraoral,SmileExtraoral,Composite,PanoramicRadiography,LateralRadiography,AditionalRadiography,BiteSTL,UpperSTL,LowerSTL";
    return queryDef;
  }



  onClickLeft() {
    this.slidesContainer.nativeElement.scrollLeft -= this.width;
  }

  onClickRight() {
    this.slidesContainer.nativeElement.scrollLeft += this.width;
  }

  onShowImage(imageToDisplay)
  {
    this.displayImage=imageToDisplay;
    this.showImage.show=true;
  }

}
